import z from "zod";

const translationPath =
  "chatBot.page.service.appointmentArrivalRule.appointmentArrivalConfig.errors.";

export const appointmentArrivalConfigSchema = z.object({
  id: z.string().optional(),
  timeStart: z.date({ invalid_type_error: translationPath + "from" }),
  timeEnd: z.date({ invalid_type_error: translationPath + "to" }),
  arrivalTime: z.date({ invalid_type_error: translationPath + "arrival_time" }),
});

export type TAppointmentArrivalConfigForm = z.infer<
  typeof appointmentArrivalConfigSchema
>;
